import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { CashCollectionsLayout } from 'src/features/cashCollections/components/CashCollectionsLayout';
import CashCollectionsTable from 'src/features/cashCollections/components/CashCollectionsTable';
import useHasPermissions from 'src/hooks/useHasPermissions.ts';

const CashCollectionsRoutes = () => {
    const permissionCashCollections = useHasPermissions([PERMISSION.CASH_COLLECTIONS]);

    return permissionCashCollections ? (
        <Routes>
            <Route path="" element={<CashCollectionsLayout />}>
                <Route path="" element={<CashCollectionsTable />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default CashCollectionsRoutes;
